import { range } from 'lodash';
import { getYear } from 'date-fns';
import { t } from '@lingui/macro';

export const yearsOptions = range(getYear(new Date()) - 10, getYear(new Date()) + 1, 1);

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const;

export const MonthsTranslatedFn = (): Record<(typeof months)[number], string> => ({
  January: t`January`,
  February: t`February`,
  March: t`March`,
  April: t`April`,
  May: t`May`,
  June: t`June`,
  July: t`July`,
  August: t`August`,
  September: t`September`,
  October: t`October`,
  November: t`November`,
  December: t`December`,
});
